import OutreachDomainService from "../Outreach/Outreach.service";
export default class PersonAlertService {
    static fromJSON(json) {
        // @ts-expect-error - TS2740 - Type '{ closedDate: any; createdDateAsDate: any; outreach: any; }' is missing the following properties from type 'PersonAlert': id, alertTypeId, alertTypeName, alertText, and 6 more.
        return Object.assign(Object.assign({}, json), { closedDate: json.closedDate && new Date(json.closedDate), createdDateAsDate: json.createdDateAsDate && new Date(json.createdDateAsDate), outreach: json.outreach && OutreachDomainService.fromJSON(json.outreach) });
    }
}
